export default __webpack_public_path__ + "static/customer_logo_mb-769798a0f58e36af5d9b2f4105cba688.png";